import React from 'react';
// eslint-disable-next-line
import SassyProps from './SASSYProps.json';
import createPlotlyComponent from 'react-plotly.js/factory';
let { colors, segments, darkColors } = SassyProps;
// import createPlotlyComponent from 'react-plotly.js/factory';
import Plotly from "./PlotlyCustom";
const Plot = createPlotlyComponent(Plotly);

const nationalDataSeries = [
  25, // Alarmed
  27, // Concerned
  17, // Cautious
  6,  // Disengaged
  13, // Doubtful
  11  // Dismissive
];

class PlotlyComparisonColumnChart extends React.Component {
  constructor(props) {
    super(props);

    let { data } = this.props;
    let series = [];
    let sortOrder = ["Alarmed", "Concerned", "Cautious", "Disengaged", "Doubtful", "Dismissive"];

    data.sort((a, b) => (sortOrder.indexOf(a.name) > sortOrder.indexOf(b.name) ? 1 : -1))

    if (data) {
      let total = data.reduce((currentValue, segment) => currentValue + segment.value, 0);
      series = data.map(segment => Math.round((segment.value / total) * 100));
    }

    this.state = {
      "data": [
        {
          "orientation": "v",
          "marker": {
            "colorsrc": "~:-101:~1001",
            "colorscale": [],
            "color": colors,
            "line": {
              "color": "#FFFFFF",
              "width": 1
            },
            "opacity": 1
          },
          "mode": "markers",
          "type": "bar",
          "name": "Group Data",
          "y": series.map(d => `${d}%`),
          "x": [
            "Alarmed",
            "Concerned",
            "Cautious",
            "Disengaged",
            "Doubtful",
            "Dismissive"
          ],
          "uid": "4ef530",
          "visible": true,
          "xaxis": "x",
          "yaxis": "y",
          "showlegend": true,
          "legendgroup": "Imported",
          "hoverlabel": {
            "namelength": 30,
            "font": {
              "family": "Arial, sans-serif",
              "size": 13
            }
          },
          "text": series.map(d => `${d}%`),
          "hovertext": "",
          "textposition": "inside",
          "insidetextfont": {
            "color": "#FFF"
          },
          "selected": {
            "marker": {
              "opacity": 1
            }
          },
          "unselected": {
            "marker": {
              "opacity": 0.2
            }
          },
          "hoverinfo": "y+name",
          "textinfo": "y",
          "opacity": 1,
          "index": 1
        },
        {
          "name": "National Estimate",
          "marker": {
            "color": "1f1f1f",
            "line": {
              "color": "#FFFFFF",
              "width": 1
            },
            "opacity": 0.9
          },
          "mode": "markers",
          "type": "bar",
          "y": nationalDataSeries,
          "x": [
            "Alarmed",
            "Concerned",
            "Cautious",
            "Disengaged",
            "Doubtful",
            "Dismissive"
          ],
          "visible": true,
          "xaxis": "x",
          "yaxis": "y",
          "showlegend": true,
          "legendgroup": "National",
          "hoverlabel": {
            "namelength": 30,
            "font": {
              "family": "Arial, sans-serif",
              "size": 13
            }
          },
          "orientation": "v",
          "text": nationalDataSeries.map(d => `${d}%`),
          "hovertext": "",
          "textposition": "outside",
          "error_y": {
            "visible": false
          },
          "error_x": {
            "visible": false
          },
          "selected": {
            "marker": {
              "opacity": 1
            }
          },
          "unselected": {
            "marker": {
              "opacity": 0.2
            }
          },
          "hoverinfo": "y+name",
          "opacity": 1,
          "index": 0
        }
      ],
      "layout": {
        "title": "Group Data vs. National Estimates (November 2025)",
        "xaxis": {
          "type": "category",
          "autorange": true,
          "visible": true,
          "categoryorder": "trace",
          "color": "#444",
          "tickmode": "auto",
          "showticklabels": true,
          "tickangle": "auto",
          "showline": false,
          "showgrid": false,
          "zeroline": false,
          "automargin": false,
          "showspikes": false,
          "anchor": "y",
          "side": "bottom",
          "domain": [
            0,
            1
          ],
          "layer": "above traces",
          "fixedrange": true,
          "tick0": 0,
          "dtick": 1
        },
        "yaxis": {
          "type": "linear",
          "autorange": true,
          "visible": true,
          "hoverformat": "",
          "color": "#444",
          "tickmode": "auto",
          "nticks": 0,
          "tickprefix": "",
          "ticksuffix": "%",
          "showticklabels": true,
          "tickangle": "auto",
          "tickformat": "",
          "showexponent": "all",
          "exponentformat": "B",
          "separatethousands": false,
          "ticks": "",
          "showline": false,
          "gridcolor": "rgb(238, 238, 238)",
          "gridwidth": 1,
          "showgrid": true,
          "zerolinecolor": "#CCC",
          "zerolinewidth": 1,
          "zeroline": true,
          "automargin": true,
          "showspikes": false,
          "anchor": "x",
          "side": "left",
          "domain": [
            0,
            1
          ],
          "layer": "above traces",
          "fixedrange": true,
          "constrain": "range",
          "constraintoward": "middle",
          "tick0": 0,
          "dtick": 20
        },
        "autosize": true,
        "paper_bgcolor": "#EFEFEF",
        "separators": ".,",
        "hidesources": false,
        "colorway": [
          "#1f77b4",
          "#ff7f0e",
          "#2ca02c",
          "#d62728",
          "#9467bd",
          "#8c564b",
          "#e377c2",
          "#7f7f7f",
          "#bcbd22",
          "#17becf"
        ],
        "hoverlabel": {
          "namelength": 30
        },
        "plot_bgcolor": "#EFEFEF",
        "barmode": "group",
        "barnorm": "",
        "bargap": 0.2,
        "bargroupgap": 0,
        "hovermode": "y+name",
        "hoverdistance": 20,
        "spikedistance": 20,
        "showlegend": true,
        "legend": {
          "bgcolor": "#FFFFFF",
          "bordercolor": "#EFEFEF",
          "borderwidth": 1,
          "orientation": "v",
          "x": 1,
          "xanchor": "right",
          "y": 1.1,
          "yanchor": "top"
        },
        "margin": {
          "pad": 24
        },
        "annotations": [],
        "shapes": [],
        "images": [],
        "updatemenus": [],
        "sliders": [],
        "breakpoints": []
      },
      "frames": [],
      "config": {
        "responsive": true,
        "displayModeBar": false
      }
    };
  }

  render() {
    return (
      <Plot className="full-width-chart"
        data={this.state.data}
        layout={this.state.layout}
        frames={this.state.frames}
        config={this.state.config}
        onInitialized={(figure) => this.setState(figure)}
        onUpdate={(figure) => this.setState(figure)}
      />
    );
  }
}

export default PlotlyComparisonColumnChart;